<template>
    <v-app>
        <v-container>
            <v-row>
                <h3>Ver Usuario</h3>
            </v-row>
            <v-row class="mt-5">
                <v-btn color="info" @click="$router.push('/user')">Volver Al Global</v-btn>
            </v-row>
            <v-row class="mt-5">
                <v-col lg="3" class="text-right mr-3">Nombre</v-col>
                <v-col lg="6">
                    <v-text-field
                        name="name"
                        label="Nombre"
                        id="name"
                        v-model="user.name"
                    >
                     <div slot="prepend">
                        <v-icon>mdi-alphabetical</v-icon>
                    </div>
                    </v-text-field>
                </v-col>
            </v-row>
            <v-row>    
                <v-col lg="3" class="text-right mr-3">Correo</v-col>
                <v-col lg="6">
                    <v-text-field
                        name="email"
                        label="Email"
                        id="email"
                        v-model="user.mail"
                    >
                     <div slot="prepend">
                        <v-icon>mdi-email</v-icon>
                    </div>
                    </v-text-field>
                </v-col>       
            </v-row>
            <v-row>    
                <v-col lg="3" class="text-right mr-3">Anticipo</v-col>
                <v-col lg="6">
                    <v-text-field
                        name="anticipo"
                        label="Anticipo"
                        id="anticipo"
                        v-model="user.anticipo"
                        type="number"
                    >
                    <div slot="prepend">
                        <v-icon>mdi-currency-usd</v-icon>
                    </div>
                    </v-text-field>
                </v-col>       
            </v-row>
            <v-row>
                <v-col lg="12" class="text-center">
                    <v-btn color="info" class="mr-5" @click="saveUser">Guardar</v-btn>
                    <v-btn color="error" class="ml-5" @click="delUser">Eliminar</v-btn>
                </v-col>
            </v-row>
        </v-container>
    </v-app>
</template>

<script>
import axios from 'axios'
import router from '../../router/index.js'

export default {
    data(){
        return {
            see_pass: false,
            see_repass: false,
            user: {
                name: '',
                mail: '',
                anticipo: 0.00
            }
        }
    },
    methods:{
        saveUser: async function(){
            try {
                let {data} = await axios.post(`https://127.0.0.1:3000/user/${this.$route.params.id}`,this.user)
                this.user=data
                
            } catch (error) {
                throw error
            }
           

        },
        getUser: async function(){
            try {
                let {data} = await axios.get(`https://127.0.0.1:3000/user/${this.$route.params.id}`)
                this.user=data
                
            } catch (error) {
                throw error
            }
        },
        delUser: async function(){
            try {
                await axios.delete(`https://127.0.0.1:3000/user/${this.$route.params.id}`)
                //console.log(data)
                this.$router.push('/users/')
            } catch (error) {
                throw error
            }
        }

    },
    mounted(){
        //Config for axios
        axios.defaults.headers.common['access-token'] = this.$store.state.token;

        axios.interceptors.response.use(function (response){
            //console.log(response.data.message);
            if (response.data.message == 'Token inválida') {
                router.push({name: 'login', params: {errorToken: 'true'}});
            }else{
                return response;
            }
        });
        //End config for axios
        this.getUser()
    }
   
}
</script>

<style>
    .pointer{
        cursor: pointer;
    }
</style>